// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".seller-header[data-v-63620dae]{background-color:#3c3c3b;margin-bottom:-15px}.seller-header .seller-container[data-v-63620dae]{background-color:#c4a181;border-bottom-left-radius:5px;border-bottom-right-radius:5px;padding-bottom:2px;z-index:1}.seller-header .seller-container .text-size[data-v-63620dae]{font-size:.75rem}", ""]);
// Exports
module.exports = exports;
